// Picks the right per-language Help Center content based on the active i18n
// language. English (the source of truth) still lives in ../helpArticles.jsx
// — the other languages live in this folder, one subdirectory per language.

import * as enModule from '../helpArticles.jsx'
import * as itModule from './it'
import * as frModule from './fr'
import * as deModule from './de'
import * as csModule from './cs'
import * as elModule from './el'

const MODULES = {
  en: enModule,
  it: itModule,
  fr: frModule,
  de: deModule,
  cs: csModule,
  el: elModule,
}

export function getHelpContent(lang) {
  const m = MODULES[lang] || MODULES.en
  return {
    HELP_CATEGORIES: m.HELP_CATEGORIES,
    HELP_ARTICLES: m.HELP_ARTICLES,
  }
}
